import { AreaUnit, DistanceUnit } from "@nova/constants"

export const rulerDistanceOptions: DistanceUnit[] = [
    DistanceUnit.Feet,
    DistanceUnit.Meters,
    DistanceUnit.Yards,
    DistanceUnit.Kilometers,
    DistanceUnit.Miles,
    DistanceUnit.NauticalMiles,
]

export const rulerAreaOptions: AreaUnit[] = [
    AreaUnit.SquareFeet,
    AreaUnit.SquareMeters,
    AreaUnit.SquareMiles,
    AreaUnit.SquareKilometers,
    AreaUnit.Acres,
    AreaUnit.Hectares,
]
